import React, {
  PropsWithChildren, Children, cloneElement, isValidElement,
} from 'react';

import { useGroupContext } from '../GroupContext';

interface IControlProps extends PropsWithChildren {
  className?: string;
}

export const Control = ({
  className,
  children,
}: IControlProps) => {
  const { isInvalid } = useGroupContext();

  const [control] = Children.toArray(children);

  const controlWithProps = isValidElement(control) ? cloneElement(control, { isInvalid } as any) : control;

  return (
    <div className={className}>
      {controlWithProps}
    </div>
  );
};
